import imageSelecter from './_image_selecter';

// バリデーションメッセージ
const INVALID_MESSAGE = {
    COLS: 'よこ軸で入力内容の重複があります',
    ROWS: 'たて軸で入力内容の重複があります',
    VALUES: '入力内容は重複できません',
};

/**
 *  表タイプ設定編集コンポーネント
 */
export default {
    template: '#table_editor_template',
    data() {
        return {
            // コンポーネントを区別するためのキー
            instance_key: ''
        };
    },
    props: {
        // 表設定データ
        table_config: {
            type: Object,
            default: () => ({}),
        },
        // 商品コード
        item_code: {
            type: String,
            default: '',
            require: false
        },
        // 編集ページID
        edit_id_dir: {
            type: [String, Number],
            required: false,
            default: null
        },
        // 詳細画像一覧
        lib_images_config: {
            type: Array,
            require: true,
        },
        // 追加データのフォーマット
        add_default_value: {
            type: Object,
            default: () => ({}),
            require: false
        },
        // 表データを編集しない時の表示内容を指定する場合の文言
        no_edit_default_values: {
            type: String,
            default: null,
            require: false
        },
        // 編集対象キー
        edit_key: {
            type: String,
            default: 'value',
            require: true
        },
        // レイアウト情報編集フラグ
        edit_layout_flag: {
            type: Boolean,
            default: false,
        },
        // 表データ編集フラグ
        edit_values_flag: {
            type: Boolean,
            default: false,
        },
        // 表データ入力の重複チェックフラグ
        values_unique_flag: {
            type: Boolean,
            default: false,
        },
        // 表データ入力をテキストエリアにするフラグ
        values_textarea_flag: {
            type: Boolean,
            default: false,
        },
        // 画像編集フラグ
        edit_image_flag: {
            type: Boolean,
            default: false,
        },
        /**
         * 表データ入力バリデーション設定
         * [
         *   {
         *     // エラーメッセージ
         *     message: 'バリデーションエラーです',
         *     // バリデーション判定関数
         *     judgment: function(value) { return true;}
         *   }
         * ]
         */
        values_valid_config: {
            type: Array,
            default: () => ([]),
            require: false
        },
        layout_valid_config: {
            type: Array,
            default: () => ([]),
            require: false
        },
    },
    /**
     * コンポーネント群
     */
    components: {
        // 画像の選択、UPロードを操作するコンポーネント
        'image-selecter': imageSelecter,
    },
    computed: {
        // 編集中のレイアウト情報
        layout: {
            get() {
                return this.table_config.layout;
            },
            set(value) {
                let tableConfig = _.cloneDeep(this.table_config);
                tableConfig.layout = value;
                this.emitUpdateTableConfig(tableConfig);
            },
        },
        // 編集中の表データ
        values: {
            get() {
                return this.table_config.values;
            },
            set(value) {
                let tableConfig = _.cloneDeep(this.table_config);
                tableConfig.values = value;
                this.emitUpdateTableConfig(tableConfig);
            },
        },
        // レイアウト情報があるか否か
        hasLayout: function () {
            return (Object.keys(this.layout).length > 0);
        },
        // 列削除ボタンを表示する
        showDelCol: function () {
            return (this.layout.cols.values.length > 1 && this.edit_layout_flag);
        },
        // 行削除ボタンを表示する
        showDelRow: function () {
            return (this.layout.rows.values.length > 1 && this.edit_layout_flag);
        },
    },
    watch: {
        // よこ軸の変更
        ['layout.cols.values']: {
            handler(values) {
                // 重複チェック
                this.layoutValidation('cols', values);
            },
            deep: true,
        },
        // たて軸の変更
        ['layout.rows.values']: {
            handler(values) {
                // 重複チェック
                this.layoutValidation('rows', values);
            },
            deep: true,
        },
        // 入力した値のバリデーション
        values: {
            handler(values) {
                this.valuesValidation(values);
            },
            deep: true,
        },
    },
    created: function () {
        // コンポーネントを区別するキーをセット
        this.instance_key = String(Math.random()).replace('.', '');
    },
    emits: ['update:table_config'],
    methods: {
        // 表示内容の重複チェック(カスタムメッセージをセットする)
        valuesValidation: function (values) {
            let uniqs = [];
            for (const rowIndex in values) {
                for (const colIndex in values[rowIndex]) {
                    const value = values[rowIndex][colIndex][this.edit_key];
                    const ref = this.valuesRefKey(rowIndex, colIndex);
                    // propsからのバリデーション判定
                    let message = this.getInvaildMessage(this.values_valid_config, value);
                    // 重複チェック
                    if (this.values_unique_flag && uniqs.indexOf(value) != -1) {
                        message = INVALID_MESSAGE.VALUES;
                    }
                    uniqs.push(value);
                    // メッセージセット
                    this.setCustomMessage(ref, message);
                }
            }
        },
        // レイアウトの重複チェック(カスタムメッセージをセットする)
        layoutValidation: function (direction, values) {
            let uniqs = [];
            for (const i in values) {
                const value = values[i].name;
                const ref = this.layoutRefKey(direction, i);
                // propsからのバリデーション判定
                let message = this.getInvaildMessage(this.layout_valid_config, value);
                // 重複チェック
                if (uniqs.indexOf(value) != -1) {
                    const key = direction.toUpperCase();
                    message = INVALID_MESSAGE[key];
                }
                uniqs.push(value);
                // メッセージセット
                this.setCustomMessage(ref, message);
            }
        },
        // 対象の値をバリデーションしてエラーならメッセージを取得する
        getInvaildMessage: function (configs, value) {
            if (configs.length > 0) {
                for (const i in configs) {
                    const config = configs[i];
                    if (!config.judgment(value)) {
                        return config.message;
                    }
                }
            }
            return '';
        },
        // 指定refにバリデーションメッセージをセットする
        setCustomMessage: function (ref, message) {
            this.$nextTick(() => {
                if (typeof this.$refs[ref] === 'undefined' || typeof this.$refs[ref][0] === 'undefined') {
                    return;
                }
                this.$refs[ref][0].setCustomValidity(message);
            });
        },
        // refキーを生成
        valuesRefKey: function (rowIndex, colIndex) {
            return 'valuesPosition_' + rowIndex + '_' + colIndex + '_' + this.instance_key;
        },
        layoutRefKey: function (direction, index) {
            return direction + 'Position_' + index + '_' + this.instance_key;
        },
        // 表データの更新
        updateValues: function (oldValues, type, index) {
            if (!this.hasLayout) {
                return [];
            }
            // レイアウト情報
            const rows = Object.keys(this.layout.rows.values);
            const cols = Object.keys(this.layout.cols.values);

            let newValues = [];
            for (const rowIndex of rows) {
                newValues[rowIndex] = [];
                for (const colIndex of cols) {
                    // 変更前の在庫データがあれば引き継ぐ
                    let value = this.getOldValue(oldValues, Number(rowIndex), Number(colIndex), type, index);
                    newValues[rowIndex].push(value);
                }
            }
            return newValues;
        },
        // 指定位置の旧表データを取得
        getOldValue: function (oldValues, rowIndex, colIndex, type, index) {
            // 行追加
            if (type === 'add-row') {
                if (index < rowIndex) {
                    rowIndex--;
                } else if (index === rowIndex) {
                    return _.cloneDeep(this.add_default_value);
                }
            }
            // 列追加
            if (type === 'add-col') {
                if (index < colIndex) {
                    colIndex--;
                } else if (index === colIndex) {
                    return _.cloneDeep(this.add_default_value);
                }
            }
            // 行削除
            if (type === 'del-row' && index <= rowIndex) {
                rowIndex++;
            }
            // 列削除
            if (type === 'del-col' && index <= colIndex) {
                colIndex++;
            }

            if (this.hasValue(oldValues, rowIndex, colIndex)) {
                return _.cloneDeep(oldValues[rowIndex][colIndex]);
            }
            return _.cloneDeep(this.add_default_value);
        },
        // 追加するレイアウトデータ
        addLayoutValue: function () {
            return {
                name: ''
            };
        },
        // 行追加
        addRow: function (index) {
            this.layout.rows.values.splice(index, 0, this.addLayoutValue());
            this.values = this.updateValues(this.values, 'add-row', index);
        },
        // 列追加
        addCol: function (index) {
            this.layout.cols.values.splice(index, 0, this.addLayoutValue());
            this.values = this.updateValues(this.values, 'add-col', index);
        },
        // 行削除
        delRow: function (index) {
            // tooltipも同時に消す
            this.$refs.rowtooltip[index].hide();
            this.layout.rows.values.splice(index, 1);
            this.values = this.updateValues(this.values, 'del-row', index);
        },
        // 列削除
        delCol: function (index) {
            // tooltipも同時に消す
            this.$refs.coltooltip[index].hide();
            this.layout.cols.values.splice(index, 1);
            this.values = this.updateValues(this.values, 'del-col', index);
        },
        // 指定位置のデータがあるか
        hasValue: function (values, rowIndex, colIndex) {
            if (typeof values[rowIndex] !== 'undefined' && typeof values[rowIndex][colIndex] !== 'undefined') {
                return true;
            }
            return false;
        },
        // 指定位置の画像URLを取得
        getImageUrl: function (rowIndex, colIndex) {
            return this.values?.[rowIndex]?.[colIndex]?.image?.urls?.[0];
        },
        // 指定位置の画像URLをセット
        setImageUrl: function (value, rowIndex, colIndex) {
            // 初期データのキーが揃っていない場合は初期データをセット
            if (typeof this.getImageUrl(rowIndex, colIndex) === 'undefined') {
                this.values[rowIndex][colIndex] = Object.assign(_.cloneDeep(this.add_default_value), this.values[rowIndex][colIndex]);
            }
            this.values[rowIndex][colIndex]['image']['urls'][0] = value;
        },
        // 指定位置の画像URLを削除
        delImageUrl: function (rowIndex, colIndex) {
            if (typeof this.values?.[rowIndex]?.[colIndex]?.image?.urls === 'undefined') {
                return;
            }
            this.values[rowIndex][colIndex]['image']['urls'].splice(0, 1);
        },

        // -------------------------
        // emit
        // -------------------------

        emitUpdateTableConfig: function (value) {
            this.$emit('update:table_config', value);
        }
    }
};
